import manageClassToPassengersMapping from "@CheckOrder/reducers/functions/manageClassToPassengersMapping";
import VehicleAddonType from "@CheckOrder/types/VehicleAddon.type";
import PassengerType from "@CheckOrder/types/Passenger.type";
import SelectedPassengerClassesType
    from "@CheckOrder/features/classPicker/types/selectedPassengerClass/SelectedPassengerClasses.type";
import createObjectFromArrayOfObjects from "@Array/createObjectFromArrayOfObjects";
import getPassengerToAutoAssignSelectedPassengerClass
    from "@CheckOrder/features/classPicker/functions/getPassengerToAutoAssignSelectedPassengerClass";
import AvailablePassengerClassType from "@CheckOrder/features/classPicker/types/AvailablePassengerClass.type";

/**
 * This is where all the business logic should be applied (how and when to group the passengers to passengersClasses)
 */
export default function passengerClassesBusinessLogic(
    passengerId: number,
    passengerClass: AvailablePassengerClassType,
    passengers: (PassengerType | VehicleAddonType)[],
    selectedPassengerClasses: SelectedPassengerClassesType,
    passengerGroupIndex?: number
) {
    const {
        removePassengerFromPreviousClassGroup,
        addPassengersToNewClassGroup,
    } = manageClassToPassengersMapping()

    const getPassengerPrice = (passengerId: number) => (
        selectedPassengerClasses.passengerToPassengerClassMap[passengerId]
            ? selectedPassengerClasses.passengerToPassengerClassMap[passengerId].price
            : 0
    )

    let updatedClassToPassengersMap = removePassengerFromPreviousClassGroup(
        selectedPassengerClasses.classToPassengersMap,
        passengerId
    )

    const passengersForThisClass = getPassengerToAutoAssignSelectedPassengerClass(
        {...selectedPassengerClasses, classToPassengersMap: updatedClassToPassengersMap},
        passengers,
        passengerId,
        passengerClass,
        passengerGroupIndex
    )

    const lostPrice = passengersForThisClass.reduce((sum, passengerId) => (
        sum + getPassengerPrice(passengerId)
    ), 0)

    const gainedPrice = passengerClass.prices[passengersForThisClass.length] * passengersForThisClass.length

    passengersForThisClass.map((passengerId) => {
        updatedClassToPassengersMap = removePassengerFromPreviousClassGroup(
            updatedClassToPassengersMap,
            passengerId
        )
    })

    updatedClassToPassengersMap = addPassengersToNewClassGroup(
        updatedClassToPassengersMap,
        passengerClass.id,
        passengersForThisClass,
        passengerGroupIndex
    )

    const updatedPassengerToPassengerClassMap = {
        ...selectedPassengerClasses.passengerToPassengerClassMap,
        ...createObjectFromArrayOfObjects(passengersForThisClass.map((passengerId) => ({[passengerId]: passengerClass}))),
    }

    return {
        updatedPassengerToPassengerClassMap,
        updatedClassToPassengersMap,
        priceDiff: gainedPrice - lostPrice,
    }
}